import api from './api';

const projectFinanceService = {
  // Listar entradas previstas
  getExpectedIncomes: async (projectId) => {
    const response = await api.get(`/projects/${projectId}/finance/expected-incomes`);
    return response.data;
  },

  // Listar pagamentos
  getPayments: async (projectId) => {
    const response = await api.get(`/projects/${projectId}/finance/payments`);
    return response.data;
  },

  // Criar pagamento
  createPayment: async (projectId, paymentData) => {
    const response = await api.post(`/projects/${projectId}/finance/payments`, paymentData);
    return response.data;
  },

  // Atualizar pagamento
  updatePayment: async (projectId, paymentId, paymentData) => {
    const response = await api.put(`/projects/${projectId}/finance/payments/${paymentId}`, paymentData);
    return response.data;
  },

  // Deletar pagamento
  deletePayment: async (projectId, paymentId) => {
    const response = await api.delete(`/projects/${projectId}/finance/payments/${paymentId}`);
    return response.data;
  },

  // Formatar valores monetários
  formatCurrency: (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  }
};

export default projectFinanceService;
